import client from './client';

export interface Classified {
  id: number;
  title: string;
  description?: string;
  price?: number;
  category: 'sell' | 'buy' | 'service' | 'rent' | 'giveaway';
  subcategory?: string;
  images?: string[];
  phone?: string;
  author_name?: string;
  district?: string;
  is_active: boolean;
  views_count: number;
  created_at: string;
}

export interface ClassifiedStats {
  total: number;
  active: number;
  by_category: Record<string, number>;
}

export const classifiedsApi = {
  list: (params?: { category?: string; is_active?: boolean }) =>
    client.get<Classified[]>('/api/admin/classifieds', { params }),

  moderate: (id: number, is_active: boolean) =>
    client.patch(`/api/admin/classifieds/${id}/moderate`, { is_active }),

  delete: (id: number) =>
    client.delete(`/api/admin/classifieds/${id}`),

  stats: () =>
    client.get<ClassifiedStats>('/api/admin/classifieds/stats'),
};
